module.exports = __webpack_public_path__ + "fonts/Montserrat-BlackItalic.b5331c5.ttf";